/**
 * TypographyKeyTokens - MD3 Expressive Typography Key Tokens Enum
 *
 * Port of androidx.compose.material3.tokens.TypographyKeyTokens (Kotlin enum class).
 * Used to reference a specific TextStyle via Typography.fromToken().
 *
 * Contains 30 keys: 15 baseline + 15 emphasized (MD3 Expressive).
 */
export enum TypographyKeyTokens {
	// ─── Baseline (15) ──────────────────────────────────────────────────────
	BodyLarge = "BodyLarge",
	BodyMedium = "BodyMedium",
	BodySmall = "BodySmall",
	DisplayLarge = "DisplayLarge",
	DisplayMedium = "DisplayMedium",
	DisplaySmall = "DisplaySmall",
	HeadlineLarge = "HeadlineLarge",
	HeadlineMedium = "HeadlineMedium",
	HeadlineSmall = "HeadlineSmall",
	LabelLarge = "LabelLarge",
	LabelMedium = "LabelMedium",
	LabelSmall = "LabelSmall",
	TitleLarge = "TitleLarge",
	TitleMedium = "TitleMedium",
	TitleSmall = "TitleSmall",

	// ─── Emphasized (15) - MD3 Expressive ───────────────────────────────────
	BodyLargeEmphasized = "BodyLargeEmphasized",
	BodyMediumEmphasized = "BodyMediumEmphasized",
	BodySmallEmphasized = "BodySmallEmphasized",
	DisplayLargeEmphasized = "DisplayLargeEmphasized",
	DisplayMediumEmphasized = "DisplayMediumEmphasized",
	DisplaySmallEmphasized = "DisplaySmallEmphasized",
	HeadlineLargeEmphasized = "HeadlineLargeEmphasized",
	HeadlineMediumEmphasized = "HeadlineMediumEmphasized",
	HeadlineSmallEmphasized = "HeadlineSmallEmphasized",
	LabelLargeEmphasized = "LabelLargeEmphasized",
	LabelMediumEmphasized = "LabelMediumEmphasized",
	LabelSmallEmphasized = "LabelSmallEmphasized",
	TitleLargeEmphasized = "TitleLargeEmphasized",
	TitleMediumEmphasized = "TitleMediumEmphasized",
	TitleSmallEmphasized = "TitleSmallEmphasized",
}
